export default __webpack_public_path__ + "static/media/cloud_deleted.427fc71f.svg";